import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Box, Modal, ModalContext, Text } from "dash-ui";
import { useTheme } from "styled-components";

const CreateChangelogConfirmationModal = () => {
  const { t } = useTranslation("pages");
  const theme = useTheme();

  const { isOpenCurrent, toggleModal, payload } = useContext(ModalContext);
  const isOpen = isOpenCurrent["CreateChangeLogModal"];
  const onClose = () => {
    toggleModal(false, "CreateChangeLogModal");
  };

  const addUpdatesToChangelog = () => {
    payload?.updateWithoutChangelog(false);
    onClose();
  };

  const dontAddUpdatesToChangelog = () => {
    payload?.updateWithoutChangelog(true);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      title={t("propertyPage.confirmChangelogCreationModalTitle") || ""}
      onRequestClose={onClose}
      submitButton={{
        title: t("propertyPage.addToChangelogButton"),
        onClick: addUpdatesToChangelog,
      }}
      cancelButton={{
        title: t("propertyPage.dontAddToChangelogButton"),
        onClick: dontAddUpdatesToChangelog,
      }}
    >
      <Box my={6}>
        <Text color={theme.colors.n80}>
          {t("propertyPage.confirmChangelogCreationModalText")}
        </Text>
      </Box>
    </Modal>
  );
};

export default CreateChangelogConfirmationModal;
